import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MonthNavigation = ({ currentMonth, changeMonth, visibleRange }) => {
  const monthName = currentMonth.toLocaleString('default', { month: 'long' });
  const year = currentMonth.getFullYear();
  const canGoBackward = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1) > visibleRange.start;
  const canGoForward = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1) <= visibleRange.end;

  return (
    <div className="flex items-center justify-between mb-6">
      {canGoBackward ? (
        <button onClick={() => changeMonth(-1)} className="p-2">
          <ChevronLeft className="text-gray-500 w-6 h-6" />
        </button>
      ) : (
        <div className="w-10" />
      )}
      <h2 className="text-2xl md:text-3xl font-semibold">{`${monthName} ${year}`}</h2>
      {canGoForward ? (
        <button onClick={() => changeMonth(1)} className="p-2">
          <ChevronRight className="text-gray-500 w-6 h-6" />
        </button>
      ) : (
        <div className="w-10" />
      )}
    </div>
  );
};

export default MonthNavigation;